import React from 'react';
import { Box, DialogTitle, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

/** Optional illustrated heading for dialogs, using the shared dialog theme. */
export default function DialogHeading({ id, icon: Icon, title, description }) {
  return <DialogTitle id={id ? `${id}-container` : undefined} component="div" sx={{ display: 'flex', alignItems: 'center', gap: 1.75 }}>
    {Icon && <Box sx={(theme) => ({
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      width: 44, height: 44, flexShrink: 0, borderRadius: '14px',
      color: 'primary.main', bgcolor: 'background.paper',
      border: `1px solid ${alpha(theme.palette.primary.main, 0.14)}`,
      boxShadow: `0 3px 8px ${alpha(theme.palette.primary.main, 0.08)}`,
    })}><Icon aria-hidden="true" /></Box>}
    <Box sx={{ minWidth: 0 }}>
      <Typography id={id} component="h2" variant="h6" sx={{ fontWeight: 700, lineHeight: 1.35 }}>
        {title}
      </Typography>
      {description && <Typography component="p" variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.5 }}>
        {description}
      </Typography>}
    </Box>
  </DialogTitle>;
}
